export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="30" y="34" width="4" height="26" rx="2" fill="#2D1E18" />
    <circle cx="32" cy="26" r="20" fill="#E11D48" />
    <path d="M12 24c4 0 4 6 8 6s4-7 8-7 4 8 8 8 4-7 8-7 4 5 8 5c0-11-9-20-20-20S12 13 12 24z" fill="#FCE8E6" />
    <rect x="22" y="12" width="6" height="2.6" rx="1.3" fill="#F59E0B" transform="rotate(-30 25 13)" />
    <rect x="36" y="10" width="6" height="2.6" rx="1.3" fill="#34D399" transform="rotate(25 39 11)" />
    <rect x="30" y="18" width="6" height="2.6" rx="1.3" fill="#60A5FA" transform="rotate(-10 33 19)" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className="f-display block text-[1.35rem] italic font-semibold text-cacao">The Sweet Shop</span>
      <span className="f-mono block text-[10px] tracking-[0.35em] text-rose">BAKERY</span>
    </span>
  </span>
);
